module.exports = __webpack_public_path__ + "img/prod_info_zdglpt.5ed45685.png";